// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1exMz","description":"PatientConsentPreview_description__1FBBq"};